import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { publicApi } from "@/lib/api";
import { useContent } from "@/lib/content";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const { data: settings = {} } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await publicApi.get("/settings")).data,
  });
  const { t } = useContent();

  return (
    <footer className="border-t border-gold/20 bg-ink-800 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <span className="font-serif text-2xl text-cream">Idea<span className="text-gold"> Events</span></span>
          <p className="mt-4 text-muted2 text-sm max-w-sm leading-relaxed">
            {settings.about || "Luxury event rentals for weddings, galas and unforgettable celebrations."}
          </p>
          <div className="flex gap-4 mt-6">
            {settings.instagram && (
              <a href={settings.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-10 h-10 rounded-full border border-gold/40 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
            )}
            {settings.facebook && (
              <a href={settings.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="w-10 h-10 rounded-full border border-gold/40 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
            )}
          </div>
        </div>

        <div>
          <h4 className="overline-label mb-4">{t("footer.explore_heading")}</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/catalog" className="text-cream/80 hover:text-gold">Catalog</Link></li>
            <li><Link to="/faqs" className="text-cream/80 hover:text-gold">FAQs</Link></li>
            <li><Link to="/contact" className="text-cream/80 hover:text-gold">Contact</Link></li>
            <li><Link to="/reservations" className="text-cream/80 hover:text-gold">My Reservations</Link></li>
            <li><Link to="/privacy" className="text-cream/80 hover:text-gold">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-cream/80 hover:text-gold">Terms of Service</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline-label mb-4">{t("footer.contact_heading")}</h4>
          <ul className="space-y-3 text-sm text-cream/80">
            {settings.contact_email && <li className="flex items-start gap-2"><Mail className="w-4 h-4 text-gold mt-0.5" /> {settings.contact_email}</li>}
            {settings.contact_phone && <li className="flex items-start gap-2"><Phone className="w-4 h-4 text-gold mt-0.5" /> {settings.contact_phone}</li>}
            {settings.address && <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-gold mt-0.5" /> {settings.address}</li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-gold/10 py-6 text-center text-xs text-muted2">
        © {new Date().getFullYear()} {t("footer.copyright")}
      </div>
    </footer>
  );
}
